import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import Spinner from "../../../components/Spinner/Spinner";
import ClientCard from "./clientCard";

class ClientForm extends Component {
  constructor(props) {
    super(props); 
    this.state = {
      banner: {
        imgUrl: "",
        imgTitle: "",
        redirectUrl: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleDeleteBanner = this.handleDeleteBanner.bind(this);
  }

  componentDidMount() {
    this.props.fetchBanner();
  }

  handleChange(e) {
    const { name, value } = e.target;
    let banner = { ...this.state.banner };
    banner[name] = value;
    this.setState({
      banner: banner,
    });
  }

  handleUpload(e) {
    let banner = { ...this.state.banner };
    banner[e.target.name] = e.target.files[0];
    this.setState({ banner: banner });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    let banner = { ...this.state.banner };
    this.props.onAddBanner(banner);
  }

  handleEditSubmit(e, editedBanner) {
    e.preventDefault();
    let banner = editedBanner;
    if (banner) {
      this.props.onEditBanner(banner, this.props.banner);
    } else {
      alert("client is null.");
    }
  }

  handleDeleteBanner(e, banner) {
    e.preventDefault();
    this.props.onDeleteBanner(banner);
  }

  render() {
    if (this.props.loading) {
      return <Spinner />;
    }

    let banner = this.props.banner;
    let bannerList =
      banner &&
      banner.map((banner, index) => (
        <ClientCard
          key={index}
          banner={banner}
          id={banner.id}
          handleEditSubmit={(e, editedCarousel) =>
            this.handleEditSubmit(e, editedCarousel)
          }
          handleDeleteBanner={this.handleDeleteBanner}
          bannerBtnLoading={this.props.bannerBtnLoading}
          deleteBtnLoading={this.props.deleteBtnLoading}
          // isAdmin={this.props.isAdmin}
        />
      ));

    return (
      <React.Fragment>
        <h3 className="text-center">Client Management</h3>
        <hr />
        <form onSubmit={this.handleFormSubmit}>
          <div className="row mx-4">
            <div class="form-group col-md-3">
              <label for="imagetitle">Enter Title</label>
              <input
                name="imgTitle"
                type="text"
                id="imagetitle"
                className="form-control"
                value={this.state.banner.imgTitle}
                onChange={this.handleChange}
                placeholder="Enter Client/Company Name"
                required
              />
            </div> 
            <div class="form-group col-md-3">
              <label for="imageurlbrand">Upload Image</label>
              <input
                name="imgUrl"
                type="file"
                id="imageurlbrand"
                className="form-control"
                onChange={this.handleUpload}
                accept=".png,.jpeg, .jpg, .webp"
                required
              />
            </div>
            <div class="form-group col-md-4">
              <label for="redirect">Redirect Url</label>
              <input
                name="redirectUrl"
                type="text"
                id="redirect"
                className="form-control"
                placeholder="Enter Redirect Url"
                onChange={this.handleChange}
                value={this.state.banner.redirectUrl}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-sm btn-success d-inline"
              style={{ marginTop: "2.2rem", marginBottom: "2rem" }}
              disabled={this.props.addBtnLoading}
            >
              {this.props.addBtnLoading ? "Saving" : "Save"}
            </button>
          </div>
        </form>
        <hr />
        <div className="row m-4">{bannerList}</div>
      </React.Fragment>
    );
  }
} 

const mapStateToProps = (state) => {
  return {
    loading: state.client.loading,
    banner: state.client.clientData,
    addBtnLoading: state.client.addBtnLoading,
    bannerBtnLoading: state.client.clientBtnLoading, 
    deleteBtnLoading: state.client.deleteBtnLoading,
  };
}; 

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBanner: () => dispatch(actions.fetchClients()),
    onAddBanner: (banner) => dispatch(actions.onAddClient(banner)),
    onEditBanner: (editedBanner, oldBannerArray) =>
      dispatch(actions.onEditClient(editedBanner, oldBannerArray)),
    onDeleteBanner: (bannerId) => dispatch(actions.onDeleteClient(bannerId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(ClientForm, Axios));
